import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';
import type { MsHighContrastMode } from '../store/schema/MsHighContrastMode';

const setMsHighContrastModeMutator: (mode: MsHighContrastMode) => void = mutatorAction(
    'setMsHighContrastMode',
    (mode: MsHighContrastMode): void => {
        getStore().mode = mode;
    }
);
export default setMsHighContrastModeMutator;
